import React, { createContext, useContext } from 'react';

export interface DualPhotoCaptureCallbacks {
  onDone: (frontUri: string, backUri: string, caption?: string) => void;
  onCancel: () => void;
  onSkipWithoutPhotos?: () => void;
  onExitCamera?: () => void;
  caption: string;
}

const DualPhotoCaptureContext = createContext<DualPhotoCaptureCallbacks | null>(null);

export function DualPhotoCaptureProvider({
  value,
  children,
}: {
  value: DualPhotoCaptureCallbacks;
  children: React.ReactNode;
}) {
  return <DualPhotoCaptureContext.Provider value={value}>{children}</DualPhotoCaptureContext.Provider>;
}

export function useDualPhotoCaptureCallbacks(): DualPhotoCaptureCallbacks {
  const ctx = useContext(DualPhotoCaptureContext);
  if (!ctx) {
    throw new Error('useDualPhotoCaptureCallbacks must be used within DualPhotoCaptureProvider');
  }
  return ctx;
}
